let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7t4XR")).then(() => parcelRequire('mEhhU'));